export enum OrderDiscountType {
	Coupon = "Coupon",
	FathersFamily = "FathersFamily",
	B2bFirstOrder = "B2bFirstOrder",
}
